import {
  del, get, post, patch,
} from './helper';

export const cancelUserOrders = async ({ orderId, userId }) => {
  const res = await del({
    url: 'admin/orders',
    data: {
      groupBuyingId: orderId,
      joinGroupId: userId,
    },
  });
  return res?.data || res;
};

export const createOrder = async (data) => {
  const res = await post({
    url: 'admin/group_buyings',
    data,
  });
  return res?.data || res;
};

export const createSchedule = async (data) => {
  const res = await post({
    url: 'admin/schedules',
    data,
  });
  return res?.data || res;
};

export const enableShareLink = async ({ orderId, enable = false }) => {
  const res = await post({
    url: `admin/group_buyings/${orderId}/share_link`,
    data: {
      enable,
    },
  });
  return res?.data || res;
};

export const getOrders = async (payload) => {
  const res = await get({
    url: 'admin/group_buyings/v2',
    data: payload,
  });
  const { data, link: { pagination } = {} } = res;
  return data && pagination ? { data, pagination } : res;
};

export const getSchedules = async (payload) => {
  const res = await get({
    url: 'admin/schedules',
    data: payload,
  });
  const { data, link: { pagination } = {} } = res;
  return data && pagination ? { data, pagination } : res;
};

export const getOrder = async (id) => {
  const res = await get({
    url: `admin/group_buyings/${id}`,
  });
  return res?.data || res;
};

export const getOrderSettings = async (id) => {
  const res = await get({
    url: `admin/group_buyings/${id}/config`,
  });
  return res?.data || res;
};

export const getSchedule = async (id) => {
  const res = await get({
    url: `admin/schedules/${id}`,
  });
  return res?.data || res;
};

export const updateOrder = async (id, data) => {
  const res = await patch({
    url: `admin/group_buyings/${id}`,
    data,
  });
  return res?.data || res;
};

export const cancelOrder = async (id) => {
  const res = await post({
    url: `admin/group_buyings/${id}/cancel`,
  });
  return res?.data || res;
};

export const finishOrder = async (id) => {
  const res = await post({
    url: `admin/group_buyings/${id}/over`,
  });
  return res?.data || res;
};

export const updateTime = async (id, config) => {
  const { startTime, endTime } = config;
  const res = await post({
    url: `admin/group_buyings/${id}/edit_time`,
    data: {
      end_time: endTime,
      start_time: startTime,
    },
  });
  return res?.data || res;
};

export const getDraft = async (id) => {
  const res = await get({
    url: `admin/drafts/${id}`,
  });
  return res?.data || res;
};

export const createDraft = async (data) => {
  const res = await post({
    url: 'admin/drafts',
    data,
  });
  return res?.data || res;
};

export const updateDraft = async (id, data) => {
  const res = await patch({
    url: `admin/drafts/${id}`,
    data,
  });
  return res?.data || res;
};

export const deleteDraft = async (id) => {
  const res = await del({
    url: `admin/drafts/${id}`,
  });
  return res?.data || res;
};

export const deleteScheduleVer2 = async (id) => {
  const res = await del({
    url: `admin/schedules/${id}`,
  });
  return res?.data || res;
};

export const stopSchedule = async (id) => {
  const res = await patch({
    url: `admin/schedules/${id}/disable`,
    data: {},
  });
  return res?.data || res;
};

export const updateMemberPaid = async (id, data) => {
  const res = await post({
    url: `admin/group_buyings/${id}/pay`,
    data,
  });
  return res?.data || res;
};

export const sendNotifyMessage = async (id, data) => {
  const res = await post({
    url: `admin/group_buyings/${id}/notify`,
    data,
  });
  return res?.data || res;
};

export const getOrderMenu = async (id) => {
  const res = await get({
    url: `admin/group_buyings/${id}/menu`,
  });
  return res?.data || res;
};

export const updateGroupBuyingsOrderMenu = async (id, menu) => {
  const res = await patch({
    url: `admin/group_buyings/${id}/menu`,
    data: {
      menu,
    },
  });
  return res?.data || res;
};

export const getGroupBuyingsOrderMenu = async (id) => {
  const res = await get({
    url: `admin/group_buyings/${id}/menu_snapshot`,
  });
  return res?.data || res;
};

export const getGroupBuyingsOrderMenuLimits = async (id) => {
  const res = await get({
    url: `admin/group_buyings/${id}/limit`,
  });
  return res?.data || res;
};

export const redirectToReimburseSite = async (id) => {
  const res = await get({
    url: `admin/group_buyings/${id}/pickup_link`,
  });
  return res;
};

export const updateEntreeLimits = async (id, data) => {
  const res = await patch({
    url: `admin/group_buyings/${id}/limit`,
    data,
  });
  return res?.data || res;
};

export const deleteSchedule = async (id) => {
  const res = await del({
    url: `admin/group_buyings/${id}/schedule`,
  });
  return res?.data || res;
};

export const updateSchedule = async ({ id, data }) => {
  const res = await patch({
    url: `admin/group_buyings/${id}/schedule`,
    data,
  });
  return res?.data || res;
};

export const updatePickupStatus = async (id, data) => {
  const res = await post({
    url: `admin/group_buyings/${id}/change_pickup_status`,
    data,
  });
  return res;
};

export const updateScheduleVer2 = async ({ id, data }) => {
  const res = await patch({
    url: `admin/schedules/${id}`,
    data,
  });
  return res?.data || res;
};

export default {
  cancelOrder,
  cancelUserOrders,
  createDraft,
  createOrder,
  createSchedule,
  deleteDraft,
  deleteSchedule,
  deleteScheduleVer2,
  enableShareLink,
  finishOrder,
  getDraft,
  getGroupBuyingsOrderMenu,
  getOrder,
  getOrderMenu,
  getOrders,
  getOrderSettings,
  getSchedule,
  getSchedules,
  redirectToReimburseSite,
  sendNotifyMessage,
  stopSchedule,
  updateDraft,
  updateEntreeLimits,
  updateGroupBuyingsOrderMenu,
  updateMemberPaid,
  updateOrder,
  updatePickupStatus,
  updateSchedule,
  updateScheduleVer2,
};
